(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bespoke-images"]) return;
  try {
    
  jQuery(function($) {
    var gallery = false;
    function initTeamGallery() {
      var e = $('.storefront-slider');
      var opts = {
        /*pagination: '.swiper-pagination',
        paginationClickable: true,*/
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      };
      if(!e.data('swipe')) { opts.noSwiping = true; }
      if(e.data('autoplay')) { opts.autoplay = parseInt(e.data('autoplay'),10); }
      if(e.data('loop')) { opts.loop = true; }
      if(e.data('slides')) { opts.slidesPerGroup = opts.slidesPerView = parseInt(e.data('slides'),10); }
opts.breakpoints = {
  768: {
  slidesPerView: 1,
  slidesPerGroup: 1
}
};
       console.log(opts,e.data('slides'));
      gallery = new Swiper('.storefront-slider',opts);
    }
    initTeamGallery();
    $(window).on('shopify:section:unload',function(e) {
      var slider = $('#-slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      gallery.destroy(true,true);
      galleryThumbs.destroy(true,true);
    });
    $(window).on('shopify:section:load',function(e) {
      console.log('load',e.originalEvent.detail.sectionId);
      var slider = $('#slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      initTeamGallery();
    });
      $(window).on('shopify:block:select',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        var idx = $('#slider-block-'+e.originalEvent.detail.blockId).index();
        if(idx<0) return;
        slider[0].swiper.slideTo(idx);
      });
      $(window).on('shopify:block:unselect',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        slider[0].swiper.slideTo(idx);
      });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-shipping"]) return;
  try {
    
/* free shipping */

jQuery(function($) {
  var dm = $('.free-shipping__message');
  if(!dm[0]) return;
  var regions = [];
  var region_divs = $('.free-shipping__region');
  jQuery.each(region_divs,function(idx,div) {
    var region = $(div);
    var countries = region.data('country-codes').replace(/\s/g,'').toUpperCase().split(',');
    regions.push({
      title:region.data('title'),
      amount: parseInt(region.data('amount')),
      countries:countries
    });
  });
  var num = 0;
  var region = '';

  var current = parseInt(dm.data('total'),10);
  //var loc = Cookies.get('location');
  var loc = window.DoublyGlobalCurrency?window.DoublyGlobalCurrency.currentCurrency:false
  $(document).on('total:change',function(event,v) {
    current = v;
    setCountry(loc);
  });
  console.log('CUR','a');

  function setCountry(cc) {
    jQuery.each(regions,function(idx,reg) {
      if(reg.countries.indexOf(cc)!=-1 || reg.countries.indexOf('*')!=-1) {
        region = reg.title;
        num = reg.amount;
        return false;
      }
    });
    var rem = (num*100)-current;
console.log('CUR',rem,current);
    if(rem<0 || !current || rem>(current/2)) {
console.log('CUR','failed',rem<0,!current,rem>(current/2));
      dm.css('display','none');     
      return;
    } else {
console.log('CUR','visible');
      rem = rem.toString();
      var pennies = rem.substring(rem.length-2);
      var remaining = rem.substring(0,rem.length-2)+(pennies=='00'?'':'.'+pennies);
    }
    var str = $('.free-shipping__hidden').data('message');
    str = str.replace('[remaining]',remaining).replace('[amount]',num/100).replace('[region]',region);
    dm.html(str).css('display','');
    $('.free-shipping__message__wrapper').css('display','');
console.log('x is',$('.free-shipping__message__wrapper')[0]);
  }

function pollCurrency() {
   var currency = window.DoublyGlobalCurrency?window.DoublyGlobalCurrency.currentCurrency:false;
  if(currency) {
    setCountry(currency);
//    console.log('currency is ',currency);
  } else {
     setTimeout(pollCurrency,100);
  }
};
setTimeout(pollCurrency,100);
/*
  if(loc) {
             
    setCountry(loc);
  } else {
   var currency = $('.currency-switcher .list .selected').data('value');
    console.log('cur is ',currency);
    $.ajax( {
    url: '//geoip.tools/v1/json',
    type: 'GET',
    dataType: 'json',
    success: function(location) {
      Cookies.set('location',location.country_code,1);
      setCountry(location.country_code);
    }
   } );
  }
*/
});
             

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-slider"] && !Shopify.designMode) return;
  try {
    
  jQuery(function($) {
    var gallery = false;
    function initHomeGallery() {
      var e = $('.homepage-slider');
      var opts = {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
      };
      if(!e.data('swipe')) { opts.noSwiping = true; }
      if(e.data('autoplay')) { opts.autoplay = parseInt(e.data('autoplay'),10); }
      if(e.data('loop')) { opts.loop = true; }
      gallery = new Swiper('.homepage-slider',opts);
    }
    initHomeGallery();
    $(window).on('shopify:section:unload',function(e) {
      var slider = $('#-slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      gallery.destroy(true,true);
      galleryThumbs.destroy(true,true);
    });
    $(window).on('shopify:section:load',function(e) {
      console.log('load',e.originalEvent.detail.sectionId);
      var slider = $('#slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      initHomeGallery();
    });
      $(window).on('shopify:block:select',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        var idx = $('#slider-block-'+e.originalEvent.detail.blockId).index();
        if(idx<0) return;
        slider[0].swiper.slideTo(idx);
      });
      $(window).on('shopify:block:unselect',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        slider[0].swiper.slideTo(idx);
      });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-the-team"]) return;
  try {
    
  jQuery(function($) {
    var gallery = false;
    function initTeamGallery() {
      var e = $('.meet-the-team-slider');
      var opts = {
        /*pagination: '.swiper-pagination',
        paginationClickable: true,*/
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      };
      if(!e.data('swipe')) { opts.noSwiping = true; }
      if(e.data('autoplay')) { opts.autoplay = parseInt(e.data('autoplay'),10); }
      if(e.data('loop')) { opts.loop = true; }
      if(e.data('slides')) { opts.slidesPerGroup = opts.slidesPerView = parseInt(e.data('slides'),10); }
opts.breakpoints = {
  768: {
  slidesPerView: 1,
  slidesPerGroup: 1
}
};
       console.log(opts,e.data('slides'));
      gallery = new Swiper('.meet-the-team-slider',opts);
    }
    initTeamGallery();
    $(window).on('shopify:section:unload',function(e) {
      var slider = $('#-slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      gallery.destroy(true,true);
      galleryThumbs.destroy(true,true);
    });
    $(window).on('shopify:section:load',function(e) {
      console.log('load',e.originalEvent.detail.sectionId);
      var slider = $('#slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      initTeamGallery();
    });
      $(window).on('shopify:block:select',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        var idx = $('#slider-block-'+e.originalEvent.detail.blockId).index();
        if(idx<0) return;
        slider[0].swiper.slideTo(idx);
      });
      $(window).on('shopify:block:unselect',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        slider[0].swiper.slideTo(idx);
      });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-side-menu"]) return;
  try {
    
jQuery(function($) {
  var sidrId = 0;
  var currentId = '';
  var clickToOpenChildren = false;
  $(window).on('shopify:section:unload',function(e) {
    if(e.originalEvent.detail.sectionId != 'mobile-side-menu') return;
    $.sidr('close', currentId);
    var cid = currentId;
    setTimeout(function() { $('#'+cid).remove(); },1500);
    $('#menu-opener-2').off();
  });
  $(window).on('shopify:section:load',function(e) {
    if(e.originalEvent.detail.sectionId != 'mobile-side-menu') return;
    initSidr();
  });
  $(window).on('shopify:section:select',function(e) {
    if(e.originalEvent.detail.sectionId != 'mobile-side-menu') return;
    setTimeout(function() { $.sidr('open', currentId); },1000);
  });
  $(window).on('shopify:section:deselect',function(e) {
    if(e.originalEvent.detail.sectionId != 'mobile-side-menu') return;
    $.sidr('close', currentId);
  });
  function getDir() {
    var optionEl = $('.mobile-side-menu');
    return optionEl.data('side');
  }
  function initSidr() {
    currentId = 'sidr-'+sidrId;
    sidrId++;
    var optionEl = $('.mobile-side-menu');
    var side = optionEl.data('side');
    var opts = {
      name:currentId,
      side: side,
      source:'.top-menu .nav-bottom-row',
      displace: optionEl.data('displace'),
      onOpen:onAnimStart,
      onClose:onAnimStart,
      onOpenEnd:onAnimEnd,
      onCloseEnd:onAnimEnd
    };
    //$('#menu-opener-2').sidr(opts);
    clickToOpenChildren = optionEl.data('click_to_open');
    $(document.body).toggleClass('sidr-hide-children',clickToOpenChildren);
  }
  function onAnimStart() {
    //$('.top-menu').css({position:'absolute',top:window.pageYOffset+'px'});
  }
  function onAnimEnd() {
    //$('.top-menu').css({position:'fixed',top:''});
  }
  $(window).click(function(e) {
    if(!clickToOpenChildren) return;
    var t = $(e.target);
//console.log('click',e,t);
    var p = $(t.parent());
    if(!t.hasClass('sidr-class-nav-parent') && !p.hasClass('sidr-class-nav-parent')) return;
/*    if(!t.hasClass('sidr-class-nav-primary-link') && !t.hasClass('sidr-class-nav-has-dropdown')) {
      return;
    }*/
    //var el = t.hasClass('sidr-class-nav-has-dropdown')?t:
    var el = t.parents('.sidr-class-nav-has-dropdown');
//    if(!el[0]) return;
    e.preventDefault();
    $('.sidr-class-nav-dropdown').slideUp(500);
    if(!el.hasClass('open')) {
      $('.sidr-class-nav-has-dropdown').removeClass('open');
      el.find('.sidr-class-nav-dropdown').slideDown(500);
      el.addClass('open');
    } else {
      $('.sidr-class-nav-has-dropdown').removeClass('open');
    }
  });
  initSidr();
  $(window).resize(function() {
     if($(window).width()>767) {
       var status = $.sidr('status');
//console.log('status',status);
       if($('.sidr.top').hasClass('open')) {
         $('.sidr.top').removeClass('open');
//         $.sidr('close',currentId);
       }
     }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
jQuery(function($) {
  $(window).on('shopify:section:select',function(e) {
    if(e.originalEvent.detail.sectionId != 'newsletter-popup') return;
    var e = $('[data-remodal-id=newsletter]');
    if(e.hasClass('disabled')) return;
    e.remodal().open();
  });
  $(window).on('shopify:section:deselect',function(e) {
    if(e.originalEvent.detail.sectionId != 'newsletter-popup') return;
    var e = $('[data-remodal-id=newsletter]');
    if(e.hasClass('disabled')) return;    
    e.remodal().close();
  });
  $(window).on('shopify:section:unload',function(ev) {
    if(ev.originalEvent.detail.sectionId != 'newsletter-popup') return;
    var e = $('[data-remodal-id=newsletter]');
    if(e.hasClass('disabled')) return;
    e.remodal().close();
    e.remodal().destroy();
    e.remove();
  });
  $(window).on('shopify:section:load',function(e) {
    if(e.originalEvent.detail.sectionId != 'newsletter-popup') return;
    var e = $('[data-remodal-id=newsletter]');
    if(e.hasClass('disabled')) return;    
    e.remodal();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-postcards"]) return;
  try {
    
jQuery(function($) {
  /*var ds = $('.artists-grid').data('src');
  var artistData = {};
  $.get(ds,function(ad) {
    artistData = ad;
    initGrid();
  });

  function initGrid() {
    $('[data-artist]').each(function(id,element) {
      el = $(element);
      var v = artistData[el.data('artist')];
      if(!v) {
        el.remove();
        return;
      }
      //el.find('img').attr('src',v.image);
      el.find('.artist-summary').html(v.summary);
      el.css('display','');
    });
  }*/
  $(window).on('shopify:section:unload',function(ev) {
    if(ev.originalEvent.detail.sectionId != 'page-meet-artists') return;
  });
  $(window).on('shopify:section:load',function(e) {
    if(e.originalEvent.detail.sectionId != 'page-meet-artists') return;
    initGrid();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-slider-2"]) return;
  try {
    
  jQuery(function($) {
    var gallery = false,
        galleryThumbs = false;
    function initGallery() {
      var pc = $('#product-slider');
      var c = pc.data('loaded-index');
      if(!c) {
        c = 0;
      }
      var opts = {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        initialSlide: c,
        onSlideChangeEnd: function(swiper){
            var activeIndex = swiper.activeIndex;
            $(galleryThumbs.slides).removeClass('is-selected');
            $(galleryThumbs.slides).eq(activeIndex).addClass('is-selected');
            galleryThumbs.slideTo(activeIndex,500, false);
        }
      }
      if(pc.data('auto_height')) {
         opts.autoHeight = true;
      }
      gallery = new Swiper('#product-slider',opts);

      var margin = $('#product-slider-control').data('margin');
      galleryThumbs = new Swiper('#product-slider-control',{
        spaceBetween: parseInt(margin,10),
        touchRatio: 0.2,
        slidesPerView: 'auto',
        //slideToClickedSlide: true,
        centeredSlides: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        onClick: function (swiper, event){
            if(!swiper.clickedIndex && swiper.clickedIndex!==0) return;
            var clicked = swiper.clickedIndex;
            swiper.activeIndex = clicked; //don't need this
            swiper.updateClasses() //don't need this
            $(swiper.slides).removeClass('is-selected');
            $(swiper.clickedSlide).addClass('is-selected');
            gallery.slideTo(clicked,500, false);
            //galleryThumbs.slideTo(clicked,500, false);
        }

      });
//      gallery.params.control = galleryThumbs;
//      galleryThumbs.params.control = gallery;
    }
    initGallery();
    $(document.documentElement).on('click','a.image-popup',function(ev) {
      if($(window).width()<768) {
        ev.preventDefault();
      }
      return;
    });
    $(window).on('shopify:section:unload',function(e) {
      if(e.originalEvent.detail.sectionId!='product-image-slider-2') return;
      gallery.destroy(true,true);
      galleryThumbs.destroy(true,true);
    });
    $(window).on('shopify:section:load',function(e) {
      console.log('load',e.originalEvent.detail.sectionId);
      if(e.originalEvent.detail.sectionId!='product-image-slider-2') return;
      initGallery();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storefronts-murals"]) return;
  try {
    
  jQuery(function($) {
    var gallery = false;
    function initTeamGallery() {
      var e = $('.storefront-slider');
      var opts = {
        /*pagination: '.swiper-pagination',
        paginationClickable: true,*/
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      };
      if(!e.data('swipe')) { opts.noSwiping = true; }
      if(e.data('autoplay')) { opts.autoplay = parseInt(e.data('autoplay'),10); }
      if(e.data('loop')) { opts.loop = true; }
      if(e.data('slides')) { opts.slidesPerGroup = opts.slidesPerView = parseInt(e.data('slides'),10); }
opts.breakpoints = {
  768: {
  slidesPerView: 1,
  slidesPerGroup: 1
}
};
       console.log(opts,e.data('slides'));
      gallery = new Swiper('.storefront-slider',opts);
    }
    initTeamGallery();
    $(window).on('shopify:section:unload',function(e) {
      var slider = $('#-slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      gallery.destroy(true,true);
      galleryThumbs.destroy(true,true);
    });
    $(window).on('shopify:section:load',function(e) {
      console.log('load',e.originalEvent.detail.sectionId);
      var slider = $('#slider-'+e.originalEvent.detail.sectionId);
      if(!slider[0]) return;
      initTeamGallery();
    });
      $(window).on('shopify:block:select',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        var idx = $('#slider-block-'+e.originalEvent.detail.blockId).index();
        if(idx<0) return;
        slider[0].swiper.slideTo(idx);
      });
      $(window).on('shopify:block:unselect',function(e) {
        var slider = $('#slider-'+e.originalEvent.detail.sectionId);
        if(!slider[0]) return;
        slider[0].swiper.slideTo(idx);
      });
});


  } catch(e) { console.error(e); }
})();
})();
